// src/firebase/auth.js
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../firebaseConfig";
import axios from "axios";
import { API_URL } from "../config";

// Set up Google Provider
const googleProvider = new GoogleAuthProvider();

// Function for Google login
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    if (!result || !auth.currentUser) {
      throw new Error("Google login failed! User not found.");
    }
    // Get Firebase ID token from the current authenticated user
    const idToken = await auth.currentUser.getIdToken();
    // Exchange the Firebase ID token for our backend JWT
    const response = await axios.post(`${API_URL}/api/auth/google-login`, { idToken });
    return response.data; // { token, user }
  } catch (error) {
    // Don't treat "user closed the popup" as a scary error
    if (error.code === "auth/popup-closed-by-user" || error.code === "auth/cancelled-popup-request") {
      throw new Error("Login cancelled.");
    }
    throw new Error(error.message || "Google sign-in failed!");
  }
};

// NOTE: Facebook login was removed from the UI because the backend has no
// /api/auth/facebook-login endpoint yet. When we build that endpoint, we can
// restore a signInWithFacebook function here and re-add the button in
// LoginModal.js.